export enum TypLokalizace {
	CZ = 'CS'
}
